import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useEffect, useState } from 'react';
import get from 'lodash/get';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import FieldLabel from './FieldLabel';
import FieldWrapper from './FieldWrapper';
import useForceUpdate from './hooks/useForceUpdate';
import devwarning from '../_utils/devwarning';
import { toArray } from '../_utils/react-children';
import FieldContext from './FieldContext';
import { INTERNAL_HOOK_KEY } from './hooks/useForm';
var DEFAULT_TRIGGER = 'onChange';
var FormEventValuePropNames = ['value', 'checked'];
var generateEventHandler = function generateEventHandler(handler, validateTrigger) {
  var eventHandler = {};
  if (validateTrigger) {
    if (typeof validateTrigger === 'string' && validateTrigger !== 'onChange') {
      eventHandler[validateTrigger] = handler;
    } else if (Array.isArray(validateTrigger)) {
      validateTrigger.forEach(function (evt) {
        if (evt !== 'onChange') {
          eventHandler[evt] = handler;
        }
      });
    }
  }
  return eventHandler;
};
export var INNER_VALUE_PROPS_LIST = [{
  name: 'Radio',
  propName: 'checked'
}, {
  name: 'Checkbox',
  propName: 'checked'
}, {
  name: 'Switch',
  propName: 'checked'
}, {
  name: 'Upload',
  propName: 'fileList'
}, {
  name: 'Transfer',
  propName: 'targetKeys'
}];
var Field = function Field(props) {
  var _context, _classnames;
  var _a;
  devwarning(! /*#__PURE__*/React.isValidElement(props.children), 'Form.Item', 'Children of Form.Item is not a valid element');
  devwarning(!props.name, 'Form.Item', 'Form.Item must have a name');
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls;
  var fieldContext = React.useContext(FieldContext);
  var forceUpdate = useForceUpdate();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    fieldValue = _useState2[0],
    setFieldValue = _useState2[1];
  var getFieldValue = fieldContext.getFieldValue,
    getFieldError = fieldContext.getFieldError,
    getInternalHooks = fieldContext.getInternalHooks,
    vertical = fieldContext.vertical,
    getDefaultValue = fieldContext.getDefaultValue,
    local = fieldContext.local,
    formDisabled = fieldContext.disabled;
  var _getInternalHooks = getInternalHooks(INTERNAL_HOOK_KEY),
    registerField = _getInternalHooks.registerField,
    dispatch = _getInternalHooks.dispatch,
    setDefaultValues = _getInternalHooks.setDefaultValues,
    deleteField = _getInternalHooks.deleteField;
  var name = props.name,
    customizeHtmlFor = props.htmlFor,
    children = props.children,
    className = props.className,
    disabled = props.disabled,
    customizePrefixcls = props.prefixCls,
    hidden = props.hidden,
    label = props.label,
    labelWidth = props.labelWidth,
    labelAlign = props.labelAlign,
    required = props.required,
    rules = props.rules,
    wrapperWidth = props.wrapperWidth,
    validateTrigger = props.validateTrigger,
    defaultValue = props.defaultValue,
    valuePropName = props.valuePropName,
    extra = props.extra;
  var htmlFor = customizeHtmlFor || (name ? _concatInstanceProperty(_context = "form_".concat(name, "_")).call(_context, (Math.random() * 100).toFixed(0)) : undefined);
  var childrenNode = null;
  var innerValuePropName = 'value';
  var childrenArray = toArray(children);
  if (childrenArray.length) {
    devwarning(childrenArray.length > 1, 'Form.Item', 'Form.Item must have only child');
    childrenNode = childrenArray[0];
  }
  var innerDisplayName = (_a = childrenNode === null || childrenNode === void 0 ? void 0 : childrenNode.type) === null || _a === void 0 ? void 0 : _a.displayName;
  if (valuePropName !== undefined) {
    innerValuePropName = valuePropName;
  } else if (innerDisplayName) {
    var filter = _filterInstanceProperty(INNER_VALUE_PROPS_LIST).call(INNER_VALUE_PROPS_LIST, function (item) {
      return innerDisplayName === item.name;
    });
    if (filter.length) {
      innerValuePropName = filter[0].propName;
    }
  }
  var onStoreChange = function onStoreChange(stores, _namePathList, source) {
    var prev = stores.prev,
      curr = stores.curr;
    var prevValue = get(prev, name);
    var currValue = get(curr, name);
    var isValueUpdated = prevValue !== currValue && source === 'updateValue';
    var isExternalAction = source === 'externalUpdateValue';
    var isValidatedFinish = source === 'validateFinish';
    var isReset = source === 'reset';
    if (isValueUpdated || isExternalAction || isValidatedFinish || isReset) {
      forceUpdate();
    }
  };
  var mergedRequired = required || (rules === null || rules === void 0 ? void 0 : rules.some(function (rule) {
    if (rule && _typeof(rule) === 'object' && rule.required) {
      return true;
    }
    if (typeof rule === 'function') {
      var ruleEntity = rule(fieldContext);
      return ruleEntity && ruleEntity.required;
    }
    return false;
  }));
  var mergeRule = function mergeRule() {
    var mergeRules = Array.isArray(rules) ? _toConsumableArray(rules) : [];
    if (!mergeRules.some(function (rule) {
      return Object.prototype.hasOwnProperty.call(rule, 'required');
    }) && required) {
      var _context2;
      mergeRules.push({
        required: true,
        message: _concatInstanceProperty(_context2 = "".concat(local && local.requiredMessage)).call(_context2, label)
      });
    }
    if (mergeRules.length) {
      mergeRules = _mapInstanceProperty(mergeRules).call(mergeRules, function (r) {
        if (typeof r === 'function') {
          return r(fieldContext);
        }
        return r;
      });
    }
    return mergeRules;
  };
  var item = {
    onStoreChange: onStoreChange,
    meta: {
      rules: mergeRule(),
      name: name,
      trigger: validateTrigger
    }
  };
  var itemRef = React.useRef(item);
  itemRef.current = item;
  useEffect(function () {
    registerField(name, itemRef);
    if (defaultValue !== undefined) {
      setDefaultValues(_defineProperty({}, name, defaultValue));
    }
  }, [name, registerField]);
  useEffect(function () {
    return function () {
      deleteField(name);
    };
  }, []);
  var formPrefixCls = getPrefixCls === null || getPrefixCls === void 0 ? void 0 : getPrefixCls(prefixCls, 'form', customizePrefixcls);
  var formItemClassName = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(formPrefixCls), true), _defineProperty(_classnames, "".concat(formPrefixCls, "-field"), true), _defineProperty(_classnames, "".concat(formPrefixCls, "-field-hidden"), hidden), _defineProperty(_classnames, "".concat(formPrefixCls, "-field-vertical"), vertical), _defineProperty(_classnames, "".concat(formPrefixCls, "-field-extra"), extra), _classnames), className);
  var value = getFieldValue(name);
  var validateMessage = getFieldError(name);
  var getInputValueFormProp = function getInputValueFormProp(evt) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var _a;
    var inputValue;
    if (innerDisplayName === 'RadioGroup' && payload) {
      inputValue = payload[1];
    } else if (evt && Object.prototype.hasOwnProperty.call(evt, 'target') && _includesInstanceProperty(FormEventValuePropNames).call(FormEventValuePropNames, innerValuePropName)) {
      inputValue = (_a = evt.target) === null || _a === void 0 ? void 0 : _a[innerValuePropName];
    } else {
      inputValue = evt;
    }
    return inputValue;
  };
  var handleValueValidate = React.useCallback(function () {
    dispatch({
      type: 'validateField',
      namePath: name
    });
  }, [name]);
  var mergeProps = function mergeProps(fa, ch) {
    var _extends2;
    if (!ch) {
      return {};
    }
    var faRest = __rest(fa, []);
    var _ch$props = ch.props,
      chChange = _ch$props.onChange,
      chValue = _ch$props[innerValuePropName],
      chDisabled = _ch$props.disabled,
      chDefaultValue = _ch$props.defaultValue;
    var onChange = function onChange() {
      for (var _len = arguments.length, evt = new Array(_len), _key = 0; _key < _len; _key++) {
        evt[_key] = arguments[_key];
      }
      var iv = getInputValueFormProp(evt[0], evt);
      if (chValue === undefined) {
        setFieldValue(iv);
      }
      dispatch({
        type: 'updateValue',
        namePath: name,
        value: iv
      });
      if (typeof chChange === 'function') {
        chChange.apply(void 0, evt);
      }
    };
    var mergeValue = chValue === undefined ? value : chValue;
    if (mergeValue !== fieldValue) {
      setFieldValue(mergeValue);
    }
    if (getDefaultValue(name) === undefined && (chDefaultValue !== undefined || chValue !== undefined)) {
      setDefaultValues(_defineProperty({}, name, chValue !== undefined ? chValue : chDefaultValue));
      forceUpdate();
    }
    var mergeResult = _extends(_extends({}, faRest), (_extends2 = {
      onChange: onChange,
      defaultValue: defaultValue
    }, _defineProperty(_extends2, innerValuePropName, fieldValue), _defineProperty(_extends2, "disabled", chDisabled !== undefined ? chDisabled : disabled !== undefined ? disabled : formDisabled), _extends2));
    var mergeEventArray = [];
    if (validateTrigger) {
      if (Array.isArray(validateTrigger)) {
        mergeEventArray.push.apply(mergeEventArray, _toConsumableArray(_filterInstanceProperty(validateTrigger).call(validateTrigger, function (v) {
          return v !== DEFAULT_TRIGGER;
        })));
      } else if (validateTrigger !== DEFAULT_TRIGGER) {
        mergeEventArray.push(validateTrigger);
      }
    }
    mergeEventArray.forEach(function (eventName) {
      mergeResult[eventName] = function () {
        var _a;
        if ((fa === null || fa === void 0 ? void 0 : fa[eventName]) && typeof fa[eventName] === 'function') {
          fa[eventName]();
        }
        if (((_a = ch.props) === null || _a === void 0 ? void 0 : _a[eventName]) && typeof ch.props[eventName] === 'function') {
          ch.props[eventName]();
        }
      };
    });
    return mergeResult;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: formItemClassName
  }, /*#__PURE__*/React.createElement(FieldLabel, {
    htmlFor: htmlFor,
    value: label,
    width: labelWidth,
    textAlign: labelAlign,
    requiredMark: mergedRequired
  }), /*#__PURE__*/React.createElement(FieldWrapper, {
    width: wrapperWidth,
    validateMessage: validateMessage,
    extra: extra
  }, _mapInstanceProperty(childrenArray).call(childrenArray, function (child, index) {
    var keys = mergeProps(_extends(_extends({}, generateEventHandler(handleValueValidate, validateTrigger)), {
      key: index,
      status: typeof validateMessage !== 'undefined' ? 'error' : undefined,
      id: customizeHtmlFor ? undefined : htmlFor
    }), child);
    return child ? /*#__PURE__*/React.cloneElement(child, keys) : child;
  })));
};
export default Field;